import controllerModal from 'pug/mixins/saveThisQuoteSingular/controllerModal'
import isAgentLogged from 'utils/pivot/agent/isAgentLogged'
import agentStore from 'utils/store/simple'

function enableSaveQuoteAgent(enable, onSubmit) {
  if (isAgentLogged()) {
    const agentInformation = agentStore.getState()
    enable && enable()
    controllerModal(agentInformation, valuesForm => {
      onSubmit(valuesForm, agentInformation)
    })
  }
}

export default enableSaveQuoteAgent
